import { Paper, Tabs } from "@mantine/core";
import { AppBreadcrumbs } from "@/Components/AppBreadcrumbs";
import { useGetApiChatEvaluationTestSetGet, useGetApiWorkspaceGet } from "@/API";
import { useParams } from "@tanstack/react-router";
import { ChatEvaluationTestList } from "./Evaluation/ChatEvaluationTestList";
import { ChatEvaluationTestSetPage } from "./Generation/ChatEvaluationTestSetPage";
import { useState } from "react";
import { IconDatabase, IconFlask } from "@tabler/icons-react";

export function ChatEvaluationTestSetIndex() {
    const { workspaceId, chatEvaluationTestSetId } = useParams({ from: "/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/" })
    const testSet = useGetApiChatEvaluationTestSetGet({ workspaceId: workspaceId, id: chatEvaluationTestSetId })

    const workspace = useGetApiWorkspaceGet({ id: workspaceId })
    const [activeTab, setActiveTab] = useState<string | null>("generation");

    return <>
        <AppBreadcrumbs
            items={[
                {
                    label: '工作空間列表',
                    linkProps: { to: '/workspace' },
                },
                {
                    label: workspace.data?.data.name ?? '',
                    linkProps: { to: '/workspace/$workspaceId', params: { workspaceId } },
                },
                {
                    label: '聊天評估',
                    linkProps: { to: '/workspace/$workspaceId/chatEvaluationTestSet', params: { workspaceId } },
                },
                {
                    label: testSet.data?.data.name ?? "測試資料",
                    active: true,
                }
            ]}
        />
        <Tabs value={activeTab} onChange={setActiveTab} radius="md" mt="xs">
            <Tabs.List mb="md">
                <Tabs.Tab value="generation" leftSection={<IconDatabase size={18} />}>
                    測試資料管理
                </Tabs.Tab>
                <Tabs.Tab value="evaluation" leftSection={<IconFlask size={18} />}>
                    評估與執行紀錄
                </Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="generation">
                <Paper shadow="sm" p="lg">
                    <ChatEvaluationTestSetPage />
                </Paper>
            </Tabs.Panel>

            <Tabs.Panel value="evaluation">
                <Paper shadow="sm" p="lg">
                    <ChatEvaluationTestList />
                </Paper>
            </Tabs.Panel>
        </Tabs>
    </>
}